<template>
  <div class="audio-setup-form">
    <div
      class="form-group audio-input-select d-flex flex-row align-items-center justify-content-between"
    >
      <span class="label mr-2">
        <i class="fal fa-microphone c-coral mr-2"></i>
        {{ $t('GENERAL.LABEL.AUDIO') }}
      </span>
      <div
        class="d-flex flex-row align-items-start justify-content-end flex-grow-1"
      >
        <div class="mr-2 w-100">
          <b-form-select
            :value="streamingProps.selectedAudioInputDevice"
            @input="
              $store.dispatch('setting/setStreamingProps', {
                selectedAudioInputDevice: $event,
              })
            "
          >
            <b-form-select-option
              v-for="device in availableAudioInputDevices"
              :key="device.deviceId"
              :value="device"
            >
              {{ device.label }}
            </b-form-select-option>
          </b-form-select>
          <div class="w-100 bg-lightest-gray rounded">
            <div
              id="mic-volume"
              class="mt-1 rounded mic-volume"
              :style="`width:${volume}%;`"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AudioSetupForm',
  props: ['stream', 'availableAudioInputDevices'],
  computed: {
    ...mapGetters({
      streamingProps: 'setting/streamingProps',
    }),
  },
  data() {
    return {
      volume: 0,
      audioContext: null,
      analyser: null,
      microphone: null,
      scriptProcessor: null,
    };
  },
  methods: {
    selectStreamDevices() {
      if (!this.streamingProps.selectedAudioInputDevice) {
        let selectedAudioInputDevice = this.availableAudioInputDevices.find(
          audio => {
            const tracks = this.stream.getAudioTracks();
            if (tracks && tracks.length)
              return tracks[0].label.indexOf(audio.label === audio.label);
            else return false;
          }
        );
        if (
          !selectedAudioInputDevice &&
          this.availableAudioInputDevices.length
        ) {
          selectedAudioInputDevice = this.availableAudioInputDevices[0];
        }
        if (selectedAudioInputDevice) {
          this.$store.dispatch('setting/setStreamingProps', {
            selectedAudioInputDevice,
          });
        }
      }
    },
    setupAudioVolumeProcessing() {
      if (!this.stream) return;
      if (this.audioContext != null) {
        this.audioContext.close();
        this.analyser.disconnect();
        this.microphone.disconnect();
        this.scriptProcessor.disconnect();
      }
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      this.audioContext = new AudioContext();
      this.analyser = this.audioContext.createAnalyser();
      this.microphone = this.audioContext.createMediaStreamSource(this.stream);
      this.scriptProcessor = this.audioContext.createScriptProcessor(
        2048,
        1,
        1
      );

      this.analyser.smoothingTimeConstant = 0.8;
      this.analyser.fftSize = 1024;

      this.microphone.connect(this.analyser);
      this.analyser.connect(this.scriptProcessor);
      this.scriptProcessor.connect(this.audioContext.destination);
      this.scriptProcessor.onaudioprocess = () => {
        const array = new Uint8Array(this.analyser.frequencyBinCount);
        this.analyser.getByteFrequencyData(array);
        let values = 0;

        const length = array.length;
        for (let i = 0; i < length; i++) {
          values += array[i];
        }

        const average = values / length;
        try {
          this.volume = average;
          // eslint-disable-next-line no-empty
        } catch (e) {}
      };
    },
  },
  destroyed() {
    if (this.audioContext != null) {
      this.audioContext.close();
      this.analyser.disconnect();
      this.microphone.disconnect();
      this.scriptProcessor.disconnect();
    }
  },
  mounted() {
    this.selectStreamDevices();
    this.setupAudioVolumeProcessing();
  },
  watch: {
    stream(value) {
      this.selectStreamDevices();
      this.setupAudioVolumeProcessing();
    },
    availableAudioInputDevices(value) {
      this.selectStreamDevices();
    },
    'streamingProps.selectedAudioInputDevice': {
      handler(value) {
        setTimeout(this.setupAudioVolumeProcessing, 200);
      },
    },
  },
};
</script>

<style lang="scss">
@import '@/web/styles/components-variables.scss';

.audio-setup-form {
  width: auto;
  max-width: 100%;
  margin-top: 15px;

  .label {
    min-width: 105px;
  }

  .right-container {
    min-width: 120px;
  }

  .v-select {
    min-width: 250px;
    max-width: 100%;
    width: 100%;
    font-size: 12px;

    .vs__dropdown-toggle .vs__clear {
      display: none;
    }

    @media screen and (max-width: 768px) {
      min-width: 100px;
    }

    .vs__dropdown-toggle {
      height: 46px;
    }
  }

  .mic-volume {
    height: 6px;
    background-color: $mustard;
    background-image: linear-gradient(to right, $mustard, $brown);
  }
}
</style>
